<template>
  <div v-if="isOpen" class="modal-container">
    <div class="backdrop" @click="close()"></div>
    <div class="modal">
      <div class="flex flex-col md:flex-row">
        <div class="flex justify-center md:justify-start">
          <img src="/images/checkout/error-icon.png" alt>
        </div>
        <div class="flex flex-col justify-center text-center md:text-left mt-4 md:mt-0 md:ml-4">
          <div class="heading-4">{{ formattedCode }}</div>
          <div class="heading-3 text-smurfs-gold">{{ formattedTitle }}</div>
        </div>
      </div>
      <div class="md:flex-1 text-md mt-2 text-center md:text-left">{{ formattedMessage }}</div>
      <div class="flex justify-center md:justify-start mt-4">
        <a class="btn btn-gold btn-ghost mr-6" @click="close()">
          <span class="btn-content">Try Again</span>
          <span class="icon">
            <i class="fas fa-sync-alt"></i>
          </span>
        </a>
        <a class="simple-btn btn-white btn-ghost" href="/help">Help</a>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash';

export default {
  props: {
    isOpen: Boolean,
    error: Object,
  },

  computed: {
    formattedCode() {
      const code = get(this.error, 'code');
      return code ? `Error #${code}` : 'Unknown Error';
    },

    formattedTitle() {
      const code = get(this.error, 'code');

      switch (code) {
        case 1000:
        case 1001:
          return `Payment couldn't be setup`;
        case 1002:
        case 1003:
        case 1004:
          return `Payment couldn't be executed`;
        default:
          return 'Something went wrong';
      }
    },

    formattedMessage() {
      return get(
        this.error,
        'error_message',
        'An expected issue occurred during the handling of your payment. Please contact the support.'
      );
    },
  },

  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-container {
  @apply fixed inset-0;
  @apply flex justify-center items-center;
  z-index: 9999;

  .backdrop {
    @apply bg-almost-black opacity-50;
    @apply absolute inset-0;
  }

  .modal {
    @apply bg-almost-black-light text-honestly-white;
    @apply flex flex-col justify-center;
    @apply p-4 z-10;
    @apply absolute inset-0;
  }

  @screen md {
    .modal {
      @apply static inset-auto;
      @apply rounded shadow-lg;
      @apply border border-honestly-white;
      width: 800px;
    }
  }
}
</style>
